// extracted by mini-css-extract-plugin
export default {"cookie-banner":"CookieBanner_cookie-banner__PcFlX","cookie-banner-content":"CookieBanner_cookie-banner-content__Jgyn1","cookie-banner-btn":"CookieBanner_cookie-banner-btn__vzVvz"};